<template>
  <a-modal
    :visible="visible"
    :title="title"
    @cancel="handleCancel"
    width="900px"
  >
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6" :sm="24">
            <a-form-item :label="$t('直播课程.小节名称')">
              <a-input v-model="queryParam.sectionName" @pressEnter="handleQuery" allow-clear/>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{$t('通用.按钮.查询')}}</a-button>
              <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{$t('通用.按钮.重置')}}</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="table-operations">
      <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['livecourse:liveCourseSection:add']">
        <a-icon type="plus" />{{$t('通用.按钮.新增')}}
      </a-button>
      <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['livecourse:liveCourseSection:remove']">
        <a-icon type="delete" />{{$t('通用.按钮.删除')}}
      </a-button>
    </div>
    <!-- 增加修改 -->
    <create-form ref="createForm" :courseId="courseId" :chapterId="chapterId" :courseList="courseList" :chapterList="chapterList" @ok="getList" />
    <a-table
      :loading="loading"
      rowKey="id"
      :columns="columns"
      :data-source="list"
      :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
      :pagination="false"
      :bordered="tableBordered"
    >
      <span slot="scheduledTime" slot-scope="text, record">
        {{ parseTime(record.scheduledTime) }}
      </span>
      <span slot="operation" slot-scope="text, record">
        <a @click="$refs.createForm.handleUpdate(record)" v-hasPermi="['livecourse:liveCourseSection:edit']">
          <a-icon type="edit" />{{$t('通用.按钮.修改')}}
        </a>
        <a-divider type="vertical" />
        <a @click="handleDelete(record)" v-hasPermi="['livecourse:liveCourseSection:remove']">
          <a-icon type="delete" />{{$t('通用.按钮.删除')}}
        </a>
      </span>
    </a-table>
    <a-pagination
      class="ant-table-pagination"
      show-size-changer
      show-quick-jumper
      :current="queryParam.pageNum"
      :total="total"
      :page-size="queryParam.pageSize"
      @showSizeChange="onShowSizeChange"
      @change="changeSize"
    />
  </a-modal>
</template>

<script>
import { pageLiveCourseSection, delLiveCourseSection } from '@/api/livecourse/liveCourseSection'
import CreateForm from '@/views/livecourse/liveCourseSection/modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'SectionModal',
  components: {
    CreateForm
  },
  mixins: [tableMixin],
  props: {
    courseId: {
      type: [String, Number],
      default: null
    },
    chapterId: {
      type: [String, Number],
      default: null
    },
    visible: {
      type: Boolean,
      default: false
    },
    courseList: {
      type: Array,
      default: () => []
    },
    chapterList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      title: '',
      list: [],
      loading: false,
      total: 0,
      selectedRowKeys: [],
      multiple: true,
      queryParam: {
        courseId: this.courseId,
        chapterId: this.chapterId,
        sectionName: undefined,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        { title: this.$t('直播课程.课程'), dataIndex: 'courseId', customRender: (text, record) => this.getCourseName(record.courseId) },
        { title: this.$t('直播课程.章节'), dataIndex: 'chapterId', customRender: (text, record) => this.getChapterName(record.chapterId) },
        { title: this.$t('直播课程.小节数'), dataIndex: 'sectionNumber' },
        { title: this.$t('直播课程.小节名称'), dataIndex: 'sectionName' },
        { title: this.$t('直播课程.预计开播时间'), dataIndex: 'scheduledTime', scopedSlots: { customRender: 'scheduledTime' } },
        { title: this.$t('通用.文本.操作'), dataIndex: 'operation', scopedSlots: { customRender: 'operation' } }
      ]
    }
  },
  created() {
    if (this.chapterId) {
      this.queryParam.courseId = this.courseId
      this.queryParam.chapterId = this.chapterId
      this.getList()
    }
  },
  watch: {
    visible: {
      handler(newVal) {
        if (newVal && this.chapterId) {
          this.queryParam.courseId = this.courseId
          this.queryParam.chapterId = this.chapterId
          this.getList()
        }
      }
    }
  },
  methods: {
    getCourseName(courseId) {
      const course = this.courseList.find(item => item.id === courseId)
      return course ? course.courseTitle : ''
    },
    getChapterName(chapterId) {
      const chapter = this.chapterList.find(item => item.id === chapterId)
      return chapter ? chapter.chapterName : ''
    },
    getList() {
      this.loading = true
      pageLiveCourseSection(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    resetQuery() {
      this.queryParam = { 
        courseId: this.courseId,
        chapterId: this.chapterId,
        sectionName: undefined,
        pageNum: 1, 
        pageSize: 10 
      }
      this.handleQuery()
    },
    handleDelete(row) {
      const that = this
      this.$confirm({
        title: this.$t('通用.文本.确认删除'),
        content: this.$t('通用.文本.删除确认数据'),
        onOk() {
          const ids = row.id || that.selectedRowKeys
          delLiveCourseSection(Array.isArray(ids) ? ids.map(id => ({ id })) : [{ id: ids }]).then(() => {
            that.getList()
            that.$message.success(that.$t('通用.文本.删除成功'))
          })
        }
      })
    },
    handleCancel() {
      this.$emit('cancel')
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
      this.multiple = !selectedRowKeys.length
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    }
  }
}
</script>